// extracted by mini-css-extract-plugin
export default {"head":"Table_head__9Vb+A","headerCell":"Table_headerCell__hWuVc","body":"Table_body__DV+Od","row":"Table_row__bAEFk","clickable":"Table_clickable__0c3-7","cell":"Table_cell__wWP80"};